import { render, staticRenderFns } from "./DeleteHolidayDateModal.vue?vue&type=template&id=858ff290&"
import script from "./DeleteHolidayDateModal.vue?vue&type=script&lang=js&"
export * from "./DeleteHolidayDateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports